import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ConnectionsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M20.707 12.293a1 1 0 010 1.414l-2 2a1 1 0 01-1.414-1.414l2-2a1 1 0 011.414 0zM3.293 12.293a1 1 0 011.414 0l2 2a1 1 0 11-1.414 1.414l-2-2a1 1 0 010-1.414zM5.57 3a.79.79 0 100 1.58.79.79 0 000-1.58zm-2.79.79a2.79 2.79 0 115.58 0 2.79 2.79 0 01-5.58 0zM1.508 8.739A3.554 3.554 0 014.68 6.78h1.79a3.55 3.55 0 013.175 1.963l.002.004.4.81a1 1 0 01-1.793.886l-.4-.808A1.55 1.55 0 006.47 8.78H4.68c-.579 0-1.114.324-1.386.858l-.397.805a1 1 0 01-1.793-.886l.404-.818zM18.43 3a.79.79 0 100 1.58.79.79 0 000-1.58zm-2.79.79a2.79 2.79 0 115.58 0 2.79 2.79 0 01-5.58 0zM14.357 8.739A3.554 3.554 0 0117.53 6.78h1.79a3.55 3.55 0 013.174 1.963l.003.004.4.81a1 1 0 01-1.794.886l-.399-.808a1.55 1.55 0 00-1.384-.855h-1.79c-.58 0-1.114.324-1.386.858l-.397.805a1 1 0 01-1.794-.886l.405-.818zM12 14.05a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0zM7.56 20.645A3.864 3.864 0 0111 18.53h2c1.457 0 2.794.822 3.445 2.123l.45.9a1 1 0 11-1.79.894l-.45-.9A1.853 1.853 0 0013 20.53h-2c-.697 0-1.335.393-1.657 1.021l-.448.896a1 1 0 01-1.79-.894l.455-.908z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
ConnectionsIcon.isCarinaIcon = true;
export default ConnectionsIcon;
